import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash';

import Collection from '../components/collection';

import { switchCollectionTabs } from '../actions/collection-action-creators';

import {
    collectionTabItemsSelector,
    isCollectionsLoading,
    selectedCollectionTabIndexSelector,
} from '../selectors/collection-selectors';
import { isEditModeSelector } from '../../common/selectors/ui-state-selectors';

export class CollectionContainer extends Component{
    handleSwitchCollectionTab = ( _, tabIndex ) => {
        const { switchCollectionTabs } = this.props;
        const tabId = get( this.props, `collectionTabItems[${tabIndex}].id`, null );

        if( !this.tabIsSelected( tabIndex ) ){
            switchCollectionTabs( tabId );
        }
    }

    tabIsSelected = ( index ) => {
        return index === this.props.activeCollectionTabIndex;
    }

    render(){
        const {
            activeCollectionTabIndex,
            collectionTabItems,
            isCollectionsLoading,
            isEditMode,
            match,
        } = this.props;

        if( isCollectionsLoading ){
            return null;
        }

        return (
            <Collection
                activeCollectionTabIndex={activeCollectionTabIndex}
                collectionTabItems={collectionTabItems}
                handleSwitchCollectionTab={this.handleSwitchCollectionTab}
                isEditMode={isEditMode}
                match={match}
            />
        );
    }
};

/* istanbul ignore next */
const mapStateToProps = ( state, props ) => {
    return {
        activeCollectionTabIndex: selectedCollectionTabIndexSelector( state, props ),
        collectionTabItems: collectionTabItemsSelector( state ),
        isCollectionsLoading: isCollectionsLoading( state ),
        isEditMode: isEditModeSelector( state ),
    };
};

CollectionContainer.propTypes = {
    activeCollectionTabIndex: PropTypes.number,
    collectionTabItems: PropTypes.array.isRequired,
    isCollectionsLoading: PropTypes.bool.isRequired,
    isEditMode: PropTypes.bool.isRequired,
    match: PropTypes.object.isRequired,
    switchCollectionTabs: PropTypes.func.isRequired,
};

export default connect( mapStateToProps, { switchCollectionTabs } )( CollectionContainer );
